export const HAS_WATCHED_SELECTED = 'has-watched'
export const ONBOARDING_SELECTED = 'user-onboard-terms'
export const TENURE_SELECTED = 'tenure-rules'
export const FOLLOWING_SELECTED = 'following'
export const CONTENT_IMPRESSION_SELECTED = 'content-impression'
export const USER_BEHAVIOR_SEGMENT_SELECTED = 'user-behavior-segment'
export const BILLING_PLAN_SELECTED = 'billing-plan'
export const RAINBOW_CATEGORY_SELECTED = 'rainbow-category'